<template>
  <div class="gs-app step5 mb-6 gm-sequence-split-assignment">
    <div class="activeicon">
      <p class="font-semibold text-base text-dark mb-2">
        {{ $t('frontend_groovemail_sequences_splitnode_split') }} *
      </p>
      <div>
        <div class="flex flex-col mt-2">
          <div
            class="w-full relative"
            :class="{
              'cursor-not-allowed':
                localModel.splitassigned && localModel.splitassigned.length > 0,
            }"
          >
            <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
            <select
              v-model="mainselect"
              :disabled="
                localModel.splitassigned && localModel.splitassigned.length > 0
              "
              :class="{
                'pointer-events-none':
                  localModel.splitassigned &&
                  localModel.splitassigned.length > 0,
              }"
              class="w-full h-10 rounded-lg text-sm bg-white border border-grey-200 text-dark pl-3 pr-7 appearance-none"
              @change="changeSelect($event)"
            >
              <option value>
                {{ $t('frontend_groovemail_sequences_splitnode_select') }}
              </option>
              <option value="list" data-name="Subscribed to list">
                {{ $t('frontend_groovemail_segment_subscribed_tolist') }}
              </option>
              <option value="list" data-name="Not subscribed to list">
                {{ $t('frontend_groovemail_segment_not_subscribed_to_list') }}
              </option>
              <option value="tag" data-name="Has tag">
                {{ $t('frontend_groovemail_segment_subscribe_has') }}
              </option>
              <option value="tag" data-name="Does not have tag">
                {{ $t('frontend_groovemail_segment_subscribe_doesnot') }}
              </option>
            </select>
          </div>
          <div class="w-full mt-2 relative" v-if="this.mainselect == 'list'">
            <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
            <select
              v-model="assignrecipient"
              @change="changerecipient($event)"
              class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
            >
              <option value>
                {{ $t('frontend_groovemail_segment_select') }}
              </option>
              <option
                v-for="(list, index) in this.lists"
                :key="index"
                :value="list.id"
                :data-name="list.name"
              >
                {{ list.name }}
              </option>
            </select>
          </div>

          <div class="w-full mt-2 relative" v-if="this.mainselect == 'tag'">
            <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
            <select
              v-model="localModel.category"
              @change="onChangecategory($event)"
              class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
            >
              <option value>
                {{ $t('frontend_groovemail_sequences_splitnode_select_category') }}
              </option>
              <option
                v-for="(category, index) in this.categories"
                :key="index"
                :value="category.id"
                :data-name="category.name"
              >
                {{ category.name }}
              </option>
            </select>
          </div>

          <div class="w-full mt-2 relative" v-if="this.mainselect == 'tag'">
            <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
            <select
              v-model="assignrecipient"
              @change="changerecipient($event)"
              class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
            >
              <option value>
                {{ $t('frontend_groovemail_sequences_splitnode_select_tag') }}
              </option>
              <option
                v-for="(tag, index) in this.tags"
                :key="index"
                :value="tag.id"
                :data-name="tag.name"
              >
                {{ tag.name }}
              </option>
            </select>
          </div>

          <div class="w-full">
            <div class="text-center w-full flex flex-row flex-wrap">
              <p
                class="list-chip font-hairline leading-8 border-0 text-primary-invert bg-primary mt-2 mr-2 relative"
                v-for="(option, index) in localModel.splitassigned"
                :key="index"
              >
                <span class="text-xs pl-2 font-semibold pr-2">
                  {{ option.main + ' ' + option.name }}
                </span>
                <span @click="deleterecipient(option)" class="px-2">
                  <span style="cursor: pointer" class="fa text-xs cross-chip"
                    >&#xf00d;</span
                  >
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import 'vue2-timepicker/dist/VueTimepicker.css';
import Category from '@/models/Category';

// import icons
import DownIcon from '@/assets/images/icons/new/down_new.svg';

export default {
  name: 'SplitNode',
  props: {
    model: {
      required: true,
    },
  },
  data() {
    return {
      localModel: this.model,
      tags: [],
      categories: [],
      lists: [],
      mainselect: '',
      mainselectname: '',
      assignrecipient: '',
      assignrecipientname: '',
      operation: '',
    };
  },

  components: {
    DownIcon,
  },

  methods: {
    deleterecipient(option) {
      const index = this.localModel.splitassigned.indexOf(option);
      this.localModel.splitassigned.splice(index, 1);
    },

    async onChangecategory(e) {
      const { data } = await axios.get('/mailtag', {
        params: { category: e.target.value },
      });
      if (data.length > 0) {
        this.tags = data;
      }
    },

    changeSelect(e) {
      this.mainselectname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      this.operation =
        this.mainselectname === 'Has tag' ||
        this.mainselectname === 'Subscribed to list'
          ? '='
          : '!=';
    },

    changerecipient(e) {
      this.assignrecipientname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      this.localModel.splitassigned.push({
        id: this.assignrecipient,
        name: this.assignrecipientname,
        type: this.mainselect,
        main: this.mainselectname,
        operation: this.operation,
      });
      this.tags = [];
      this.assignrecipient = '';
      this.assignrecipientname = '';
      this.mainselect = '';
      this.mainselectname = '';
      this.operation = '';
    },
  },

  async created() {
    const mailLists = await axios.get(`/maillistonly`);
    this.lists = mailLists?.data?.data;
    this.categories = await Category.$get();
  },

  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    },
  },
};
</script>

<style scoped>
.gm-sequence-split-assignment select {
  min-height: 2.75rem;
  height: 2.75rem;
  color: var(--gs-foreground);
  border-color: var(--gs-border);
}

.gm-sequence-split-assignment select:focus {
  outline: 2px solid var(--gs-primary);
  outline-offset: 2px;
}

.gm-sequence-split-assignment .list-chip {
  display: inline-flex;
  align-items: center;
  min-height: 2.75rem;
  max-width: 100%;
  margin-right: 0;
  padding-left: 0.5rem;
  color: var(--gs-foreground);
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-md);
  overflow-wrap: anywhere;
}

.gm-sequence-split-assignment .list-chip > span:first-child {
  min-width: 0;
  padding-right: 0.5rem;
}

.gm-sequence-split-assignment .list-chip > span:last-child {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  min-width: 2.75rem;
  min-height: 2.75rem;
  padding: 0;
  color: var(--gs-danger);
}

.gm-sequence-split-assignment .list-chip > span:last-child:focus-within {
  outline: 2px solid var(--gs-primary);
  outline-offset: -2px;
}

@media (max-width: 40rem) {
  .gm-sequence-split-assignment .list-chip {
    width: 100%;
    text-align: left;
  }
}
</style>
